<div class="popup-overlay" [@fadeInOut] (click)="onDialogClick($event)">
	<div class="popup-container" [@slideInOut] (click)="$event.stopPropagation()">
		<div class="popup-content">
			<div class="icon-container">
				<div class="icon-circle">
					<span class="material-icons warning-icon">warning_amber</span>
				</div>
			</div>
			
			<div class="popup-header">
				<h2>Confirmation requise</h2>
				<div class="header-line"></div>
			</div>

			<div class="popup-body">
				<p>{{data.msg}}</p>
			</div>

			<div class="popup-actions">
				<button class="btn-cancel ripple" (click)="onCancel(); $event.stopPropagation()">
					<span class="material-icons">close</span>
					<span class="btn-text">Annuler</span>
				</button>
				<button class="btn-confirm ripple" (click)="onConfirm(); $event.stopPropagation()">
					<span class="material-icons">check_circle</span>
					<span class="btn-text">Confirmer</span>
				</button>
			</div>
		</div>
	</div>
</div>     
